import '.a{display:flex;}.ssr-plugin'
import '.t{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ab{gap:0.5rem;}.ssr-plugin'
import '.ai{cursor:pointer;}.ssr-plugin'
import '.gx{padding:0.75rem;}.ssr-plugin'
import '.am{border-radius:1.25rem;}.ssr-plugin'
import '.ad{border:var(--blue-border);}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.cr{transition:background-color 0.2s ease;}.ssr-plugin'
import '.dh{width:2.5rem;}.ssr-plugin'
import '.di{height:2.5rem;}.ssr-plugin'
import '.gy{color:var(--shades-blue-700);}.ssr-plugin'
import '.gz{font-size:0.9rem;}.ssr-plugin'
import '.b2{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a t b c ab ai gx am ad ac cr"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="dh di a c t gy"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="gz gy b2"
        >
          {label}
        </span>
      </styled.button>
    )
}